import { render } from "../address_match_verification/address_match_verification.html?vue&type=template&id=13f1fa28&external"
import script from "../address_match_verification/address_match_verification.js?vue&type=script&lang=js&external"
export * from "../address_match_verification/address_match_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__